import { Component, Input, OnInit } from '@angular/core';
import { StandardrechtMasterDetailEntryMeta } from '../../../core/gb-api/model/standardrechtMasterDetailEntryMeta';
import { PfandrechtMasterDetailEntryMeta } from '../../../core/gb-api/model/pfandrechtMasterDetailEntryMeta';
import { StandardrechtVersionDetailEntryMeta } from '../../../core/gb-api/model/standardrechtVersionDetailEntryMeta';
import { PfandrechtVersionDetailEntryMeta } from '../../../core/gb-api/model/pfandrechtVersionDetailEntryMeta';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { ReadMoreComponent } from '../../../shared/widgets/read-more/read-more.component';
import { TranslatePipe } from '@ngx-translate/core';
import { YesNoPipe } from '../../../shared/pipes/simple/yes-no.pipe';

@Component({
  selector: 'cap-bereinigungsmarkierung',
  templateUrl: './bereinigungsmarkierung.component.html',
  styleUrls: ['./bereinigungsmarkierung.component.scss'],
  imports: [KopfdatenelementComponent, ReadMoreComponent, TranslatePipe, YesNoPipe]
})
export class BereinigungsmarkierungComponent implements OnInit {
  constructor() {}

  @Input()
  recht: StandardrechtMasterDetailEntryMeta | PfandrechtMasterDetailEntryMeta;

  @Input()
  version: StandardrechtVersionDetailEntryMeta | PfandrechtVersionDetailEntryMeta;

  ngOnInit() {}
}
